import React from "react";
import TwoFactorVerifyForm from "../TwoFactorVerifyForm";

const TwoFactorVerify = () => {
  return (
    <div className="min-h-svh w-full flex items-center justify-center bg-muted text-foreground p-6">
      <TwoFactorVerifyForm />
    </div>
  );
};

export default TwoFactorVerify;
